import ApiMethods from '../ApiMethods';
import Endpoints from '../Endpoints';

/**
 * RUTEX Customer API Manager Service
 */
export const CustomerApiManager = {
  /**
   * Fetch filtered & paginated list of customers
   * @param {object} params (search, estatus, page, per_page)
   */
  getCustomers: async (params = {}) => {
    return await ApiMethods.get(Endpoints.CUSTOMERS, { params });
  },

  /**
   * Create a new customer manually (defaults to 'inactive' / Invitado / Sin Clave status)
   * @param {object} customerData 
   */
  createCustomer: async (customerData) => {
    if (customerData instanceof FormData) {
      return await ApiMethods.post(Endpoints.CUSTOMERS, customerData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    }
    return await ApiMethods.post(Endpoints.CUSTOMERS, customerData);
  },

  /**
   * Import customers from Excel/CSV file
   * @param {FormData} formData 
   */
  importCustomers: async (formData) => {
    return await ApiMethods.post(Endpoints.CUSTOMER_IMPORT, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  /**
   * Download official Excel bulk load template
   */
  downloadImportTemplate: async () => {
    return await ApiMethods.get(Endpoints.CUSTOMER_IMPORT_TEMPLATE, {
      responseType: 'blob'
    });
  },

  /**
   * Update existing customer information
   * @param {string|number} id 
   * @param {object} customerData 
   */
  updateCustomer: async (id, customerData) => {
    if (customerData instanceof FormData) {
      customerData.append('_method', 'PUT');
      return await ApiMethods.post(Endpoints.CUSTOMER_BY_ID(id), customerData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    }
    return await ApiMethods.put(Endpoints.CUSTOMER_BY_ID(id), customerData);
  },

  /**
   * Approve a pending customer registration
   * @param {string|number} id 
   * @param {object} approveData (e.g. { limite_credito })
   */
  approveCustomer: async (id, approveData) => {
    return await ApiMethods.patch(Endpoints.CUSTOMER_APPROVE(id), approveData);
  },

  /**
   * Toggle status (e.g., active / disabled) of a customer
   * @param {string|number} id 
   * @param {string} estatus 
   */
  toggleCustomerStatus: async (id, estatus) => {
    return await ApiMethods.patch(Endpoints.TOGGLE_CUSTOMER_STATUS(id), { estatus });
  }
};

export default CustomerApiManager;
